/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebcover2Inputs */

const en_placewebcover2 = /** @type {(inputs: Placewebcover2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cover`)
};

const de_placewebcover2 = /** @type {(inputs: Placewebcover2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titelbild`)
};

/**
* | output |
* | --- |
* | "Cover" |
*
* @param {Placewebcover2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebcover2 = /** @type {((inputs?: Placewebcover2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebcover2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebcover2(inputs)
	return de_placewebcover2(inputs)
});
export { placewebcover2 as "placeWebCover" }